import { defineComponent as _defineComponent } from 'vue'
import type { GetPopularTitlesQueryVariables } from '@/pages/graphql/queries/GetPopularTitles.query';

import { ModalHelper } from '@/helpers/modal-helper';

import ReelView from '@/components/experiments/ReelsExp/components/ReelView.vue';
import ReelsExp from '../index';

import { useReels } from '@/components/experiments/ReelsExp/components/query';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReelModal',
  props: {
    queryVariables: null,
    title: null
  },
  setup(__props: any) {

const props = __props as {
	queryVariables: GetPopularTitlesQueryVariables;
	title: string;
};



function close() {
	ReelsExp.trackEvent({ action: 'click', label: 'close_overlay', property: 'shorts_popular' });
	ModalHelper.close();
}

const { loading, reelTitles, fetchMoreReels } = useReels(() => props.queryVariables);

const selectedIndex = computed(() =>
	props.title === '' ? 0 : reelTitles.value.findIndex(title => title.node.id === props.title)
);

function checkLoadMore(currentIndex: number) {
	if (Math.abs(currentIndex - reelTitles.value.length) <= 3) fetchMoreReels();
}

return { __sfc: true,props, close, loading, reelTitles, fetchMoreReels, selectedIndex, checkLoadMore, ReelView }
}

})